import React from "react";

import { EuiFlexGrid } from "@elastic/eui";

import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import DropoffAccordionSection from "./DropoffAccordionSection";
import * as S from "../../../style";
import { mapResourceObjectToArray } from "../../../../../utils/jsonApiUtils";
import { getUserRoles } from "../../../../auth/slice";
import { userRoles } from "../../../../../constants/userRoles";

const DropoffAccordion = ({
    tripDropoffs,
    attachments,
    onDropOffFieldChange,
    isDropoffFieldsEditable,
    alwaysEditableFields,
}) => {
    const intl = useIntl();
    const getCurrentUserRoles = useSelector(getUserRoles());
    const loadedAmountIsEditable =
        getCurrentUserRoles.some((role) => role === userRoles.ACCOUNT_MANAGER) ||
        isDropoffFieldsEditable;

    return tripDropoffs.map((dropoff, i) => {
        const attachements = attachments.filter((a) => a.attachedItemId === +dropoff.id);
        const locationAttributes = mapResourceObjectToArray(dropoff.locationAttributes)[0];
        const timeSpentDuration =
            dropoff.departureTime && dropoff.arrivalTime
                ? moment(dropoff.departureTime).diff(moment(dropoff.arrivalTime)) / 1000
                : null;

        const handleDropOffField = (fieldName, pointField, successCallBack) => {
            if (pointField[fieldName] === null) {
                onDropOffFieldChange(pointField, dropoff.id);
                return;
            }

            if (fieldName === "shipmentNumberOfUnits") {
                pointField[fieldName] = +pointField[fieldName];
            }

            if (fieldName === "arrivalTime" || fieldName === "departureTime") {
                pointField[fieldName] = pointField[fieldName].locale("en").format();
            }

            onDropOffFieldChange(pointField, dropoff.id, successCallBack);
        };

        const accordionBtnContent = locationAttributes
            ? `${locationAttributes.cityName} - 
        ${
            locationAttributes.nameAr ||
            locationAttributes.nameEn ||
            locationAttributes.name ||
            locationAttributes.address
        }`
            : dropoff.cityName;

        const pointName = locationAttributes
            ? locationAttributes.nameAr ||
              locationAttributes.nameEn ||
              locationAttributes.name ||
              locationAttributes.address
            : dropoff.cityName;

        return (
            <S.StyledAccordion
                key={dropoff.id}
                id={dropoff.id}
                buttonContent={accordionBtnContent}
                initialIsOpen={i === 0}
                paddingSize="none"
                marginBottom={i < tripDropoffs.length}
            >
                <EuiFlexGrid
                    columns={3}
                    gutterSize="m"
                    className="dropoff__section-wrapper"
                >
                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        iconType="crosshairs"
                        title={<FormattedMessage id="trip.dropoff-location-category" />}
                        fieldType="string"
                        fieldName="locationCategoryName"
                        value={dropoff.locationCategoryName}
                        isEditable={false}
                    />

                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        value={dropoff.shipmentNumberOfUnits}
                        iconType="logstashInput"
                        title={<FormattedMessage id="trip.dropoff-unloaded-amount" />}
                        fieldType="number"
                        fieldName="shipmentNumberOfUnits"
                        isEditable={loadedAmountIsEditable}
                    />

                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        iconType="logstashInput"
                        title={<FormattedMessage id="trip.dropoff-unloaded-unit" />}
                        fieldType="shipmentUnit"
                        fieldName="shipmentUnit"
                        value={intl.formatMessage({ id: `shipmentUnit.${dropoff.shipmentUnit}` })}
                    />

                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        iconType="visGauge"
                        title={<FormattedMessage id="trip.dropoff-unloading-duration" />}
                        fieldType="duration"
                        fieldName="timeSpent"
                        value={timeSpentDuration}
                    />
                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        iconType="clock"
                        title={<FormattedMessage id="trip.dropoff-arrival-time" />}
                        fieldName="arrivalTime"
                        fieldType="dateAndTime"
                        value={dropoff.arrivalTime}
                        isEditable={isDropoffFieldsEditable}
                    />

                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        iconType="clock"
                        title={<FormattedMessage id="trip.dropoff-departure-time" />}
                        fieldName="departureTime"
                        fieldType="dateAndTime"
                        value={dropoff.departureTime}
                        isEditable={isDropoffFieldsEditable}
                    />

                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        iconType="paperClip"
                        title={<FormattedMessage id="trip.dropoff-pod-doc" />}
                        fieldType="attachment"
                        fieldName="attachment"
                        value={attachements}
                        isEditable={alwaysEditableFields}
                        pointName={pointName}
                    />

                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        iconType="paperClip"
                        title={<FormattedMessage id="trip.dropoff-pod-number" />}
                        fieldType="number"
                        fieldName="podNumber"
                        value={dropoff.podNumber}
                        isEditable
                    />

                    <DropoffAccordionSection
                        onDropOffFieldChange={handleDropOffField}
                        iconType="indexEdit"
                        title={<FormattedMessage id="trip.dropoff-notes" />}
                        fieldType="string"
                        fieldName="notes"
                        value={dropoff.notes}
                        isEditable
                    />
                </EuiFlexGrid>
            </S.StyledAccordion>
        );
    });
};

export default DropoffAccordion;
